<template>

	<div class="change_psw clearfix p_background">
		<h3 class="all_title">修改密码</h3>
		<section class="psw_container text-center container_box">
			<div class="change_psw_box">

				<section class="psw">
					<label for="">输入旧密码</label>
					<input type="password" class="" id="oldPwd" maxlength="20" v-model="oldPwd" />
				</section>

				<section class="psw">
					<label for="">输入新密码</label>
					<input type="password" class="" id="newPwd" maxlength="20" v-model="password" />
				</section>

				<section class="confirm_psw">
					<label for="">再次输入新密码</label>
					<input type="password" class="" id="confirmPwd" maxlength="20" v-model="confirmPassword" />
				</section>

				<p class="text-center">
					<input type="buttom" id="subBtn" class="btn btn_submit btn_h" @click="updatePwd()" value="修改密码" />
				</p>
			</div>
		</section>

	</div>

</template>

<script>
	import { MessageBox } from 'element-ui'

	export default {
		name: 'change_psw',
		data() {
			return {
				oldPwd: '',
				password: '',
				confirmPassword: ''
			}
		},
		methods: {
			updatePwd() {
				var temp = this;
				var oldPwd = this.oldPwd.trim();
				var password = this.password.trim();
				var comfrim = this.confirmPassword.trim();
                var ispwd=/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{8,}$/;

				if(oldPwd.trim() == '' || password.trim() == '' || comfrim.trim() == '') {
					MessageBox('密码不能为空！', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return;
				} /*else if(oldPwd.length > 0 && oldPwd.length < 8 || oldPwd.length > 19) {
					MessageBox('密码长度应为8到20个字符以内！', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return;
				} */else if(!ispwd.test(password)) {
					MessageBox('密码由8位以上数字、字母和特殊符号组成！', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return;
				} else if(!ispwd.test(comfrim)) {
					MessageBox('密码由8位以上数字、字母和特殊符号组成！', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return;
				} else if(password.trim() != comfrim.trim()) {
					MessageBox('新密码两次输入不一致！', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return;
				}
				this.$http.post('/zklccloud/updatePassword', {
					"oldPassword": oldPwd,
					"passwords": comfrim
				}, {
					emulateJSON: true
				}).then(function(m) {
					if(m.body.data == "success") {
						//$("#one").addClass("state_success").removeClass("state_caution");
						MessageBox('修改成功,建议使用新密码重新登录！', '提示', 'success', {
							confirmButtonText: '确定',
						}).then(() => {
							this.$router.push("/login");
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}

						//						temp.trueFlag = true;
						//						//temp.tipMsg = "修改成功,请使用新密码重新登录";
						//						$("#one").modal().find(".state_text").html('修改成功,建议使用新密码重新登录');
						//						temp.tipNum = "1";
						return;
					} else if(m.body.data == "error") {
						MessageBox('旧密码不正确！', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return;
					} else if(m.body.data == "errornull") {
						MessageBox('密码不能为空！', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return;
					}
				});
			},
		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// change_password.vue?33ea13dc